import { render, staticRenderFns } from "./DeckPlan.vue?vue&type=template&id=83c1159c"
import script from "./DeckPlan.vue?vue&type=script&lang=js"
export * from "./DeckPlan.vue?vue&type=script&lang=js"
import style0 from "./DeckPlan.vue?vue&type=style&index=0&id=83c1159c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports